import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import WhatIs from './components/WhatIs';
import WhyUse from './components/WhyUse';
import Comparison from './components/Comparison';
import Safety from './components/Safety';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ArticleCards from './components/ArticleCards';

const SITE_URL = 'https://vigorbuyspread.hair';
const OG_IMAGE = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg';

export default function Home() {
  return (
    <>
      <title>Vigorbuy Spreadsheet | Updated Product Lists, Guides &amp; Shopping Resources</title>
      <meta name="description" content="Discover the latest Vigorbuy Spreadsheet guides, product lists, category databases, comparison tables and expert shopping resources. Your complete resource for organized product research and smarter shopping." />
      <meta name="keywords" content="Vigorbuy Spreadsheet, Vigorbuy product spreadsheet, spreadsheet shopping guide, Vigorbuy categories, product research spreadsheet" />
      <link rel="canonical" href={`${SITE_URL}/`} />
      <meta property="og:title" content="Vigorbuy Spreadsheet | Updated Product Lists, Guides &amp; Shopping Resources" />
      <meta property="og:description" content="Discover the latest Vigorbuy Spreadsheet guides, product lists, category databases, comparison tables and expert shopping resources." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE_URL}/`} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Vigorbuy Spreadsheet | Updated Product Lists, Guides &amp; Shopping Resources" />
      <meta name="twitter:description" content="Discover the latest Vigorbuy Spreadsheet guides, product lists, category databases, comparison tables and expert shopping resources." />
      <meta name="twitter:image" content={OG_IMAGE} />

      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ArticleCards />
        <WhatIs />
        <WhyUse />
        <Comparison />
        <div id="safety-section">
          <Safety />
        </div>
        <div id="faq-section">
          <FAQ />
        </div>
        <CTASection />
      </main>
      <Footer />
    </>
  );
}